import { render, staticRenderFns } from "./confirmpayment.vue?vue&type=template&id=38d289df&scoped=true&"
import script from "./confirmpayment.vue?vue&type=script&lang=js&"
export * from "./confirmpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d289df",
  null
  
)

export default component.exports